<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          所属机构
        </div>
        <el-select
          v-model="searchForm.recommendAgencyId"
          placeholder="请选择所属机构"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.evaluationStatus"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in evaluationStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          行业
        </div>
        <el-select
          v-model="searchForm.evaluationId"
          placeholder="请选择行业"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in evaluationList"
            :key="item.id"
            :label="item.evaluationName"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          开始时间
        </div>
        <el-date-picker
          v-model="searchForm.createTimeStart"
          type="date"
          placeholder="选择开始时间"
          value-format="timestamp"
          @change="getList()"
        />
        <div class="label">
          结束时间
        </div>
        <el-date-picker
          v-model="searchForm.createTimeEnd"
          type="date"
          placeholder="选择结束时间"
          value-format="timestamp"
          @change="getList()"
        />
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.createByMobilePhone"
          placeholder="请输入学员手机号"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <!-- 题目分类 -->
    <category-score-dialog
      :dialog-visible.sync="categoryScoreItemDialog"
      :list="categoryScoreList"
    />
    <!-- 题目分类 -->
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import {
  evaluationStatusList,
} from '@/config';
import categoryScoreDialog from '../dialog/categoryScoreDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    categoryScoreDialog,
  },
  data() {
    return {
      evaluationStatusList,
      evaluationList: [],
      agencyList: [], // 机构列表
      tabelData: {},
      categoryScoreItemDialog: false,
      categoryScoreList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        recommendAgencyId: '', // 所属机构id
        evaluationStatus: '',
        evaluationId: '', // 行业id
        createByMobilePhone: '',
        createTimeStart: null,
        createTimeEnd: null,
      },
      tableColumn: [
        {
          key: 'id',
          label: '订单id',
          dataType: 'text',
        },
        {
          key: 'evaluationName',
          label: '行业名称',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'createByRealName',
          label: '学员名称',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'createByMobilePhone',
          label: '学员手机',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'recommendAgencyName',
          label: '推荐机构',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'actualPayAmount',
          label: '支付金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'agencyDistributionExtractAmount',
          label: '机构分销金额',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyDistributionExtractTime',
          label: '机构分销金额提取时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'evaluationStatus',
          label: '状态',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => evaluationStatusList.filter((item) => item.value === key),
        },
        {
          key: 'totalScore',
          label: '考试成绩',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'evaluationAwardName',
          label: '中奖奖品',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '240px',
          dataType: 'component',
          renderProps: [
            {
              text: '查看分类成绩', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },

  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.evaluation.evaluationOrderPageBackend(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    async selectList() {
      this.evaluationList = await axClient.evaluation.evaluationSelect();
      this.agencyList = await axClient.registration.listNameByRegistration();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.openCategoryDialog(item);
          break;
        default:
          break;
      }
    },
    openCategoryDialog(item) {
      this.categoryScoreList = item.scoreList;
      this.categoryScoreItemDialog = true;
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        courseCompleteTime: {
          ascending: 30,
          descending: 40,
        },
        courseExpireTime: {
          ascending: 10,
          descending: 20,
        },
        createTime: {
          ascending: 50,
          descending: 60,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
